import React from "react"
import { Text, TouchableOpacity, View } from "react-native"
import { CheckboxProps } from "./props"
import { styles } from "./styles"
import { colors } from "colors"
import { useColor } from "app/theme/getThemes"

export const CheckBox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  style,
  boxColor = "#f0f0f0",
}) => {
  const { companyTheme } = useColor()

  return (
    <TouchableOpacity
      style={[styles.container, style]}
      onPress={() => onChange(!checked)}
      activeOpacity={0.8}
    >
      <View
        style={[
          styles.checkboxBase,
          checked
            ? { backgroundColor: companyTheme.first, borderColor: companyTheme.first }
            : styles.checkboxUnchecked,
          !checked && { backgroundColor: boxColor },
        ]}
      >
        {checked && <Text style={styles.tickIcon}>✓</Text>}
      </View>
      {label && <Text style={styles.label}>{label}</Text>}
    </TouchableOpacity>
  )
}
